import { bulletPoint } from "../../assets/icons.js";
import { RichText } from "../../internal-components/rich-text/richText.js";

interface Props {
  title?: string;
  points: { point: string }[];
}

const BulletPoints: React.FC<Props> = ({ points, title }) => (
  <div className="bullet-points">
    <div className="content mw-small">
      <h2 className="title">{title}</h2>
      <ul>
        {points.map((point, i) => (
          <li key={i}>
            {bulletPoint}
            <RichText html={point.point} />
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default BulletPoints;
